// extracted by mini-css-extract-plugin
export default {"container":"yM-z","topReviewHeading":"zM-z","criticalReview":"AM-z","favorableReview":"BM-z","vsSeparator":"CM-z"};